module.exports = __webpack_public_path__ + "img/cancelled_invoice_amount.bdaa358b.svg";